import api from 'api';

// Admin-only slug tools behind the alert form's URL field. Both call the axios
// instance directly so the API's own message (e.g. a 409) reaches the admin.

const unwrap = (res) => res.data.data;

// Short default built from the subject line, already made unique.
export const suggestAlertSlug = async (title) =>
    unwrap(await api.get('/alerts/slug-tools/suggest', { params: { title } }));

// { slug: normalised, available }. alertId excludes the alert being edited.
export const checkAlertSlug = async (slug, alertId) =>
    unwrap(
        await api.get('/alerts/slug-tools/availability', {
            params: alertId ? { slug, alertId } : { slug },
        })
    );

export const apiErrorMessage = (payload, fallback) => {
    const message = payload?.message;
    if (Array.isArray(message)) return message.join(' ');
    return typeof message === 'string' && message ? message : fallback;
};
